var _defs, _path, _g, _tspan, _tspan2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 241.8",
    style: {
      enableBackground: "new 0 0 800 241.8"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#0048AE;}\t.st1{fill:#FFFFFF;stroke:#0048AE;stroke-miterlimit:10;}\t.st2{opacity:0.2;fill:#FFFFFF;stroke:#0048AE;stroke-miterlimit:10;enable-background:new    ;}\t.st3{opacity:0.12;fill:#FFFFFF;stroke:#0048AE;stroke-miterlimit:10;enable-background:new    ;}\t.st4{opacity:0.25;fill:#FFFFFF;stroke:#0048AE;stroke-miterlimit:10;enable-background:new    ;}\t.st5{fill:#FFFFFF;}\t.st6{font-family:'Poppins-Regular';}\t.st7{font-size:75.4703px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M770.4,241.2H29.6C13,241.2,0,228.2,0,211.6V33.8C0,17.2,13,4.2,29.6,4.2h740.7c16.6,0,29.6,13,29.6,29.6v177.8 C800,228.2,787,241.2,770.4,241.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.6,48.6c-1.8,1.8-2.4,4.7-2.4,8.3v131c0,3.6,1.2,6.5,3,8.3l0.6,0.6l73.5-73.5v-1.2L61.6,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160,148.2l-24.3-24.3v-1.8L160,97.8l0.6,0.6l29,16.6c8.3,4.7,8.3,12.4,0,17.2L160,148.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.6,147.6l-24.9-24.9l-74.1,74.1c3,3,7.1,3,12.4,0.6L160.6,147.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.6,97.8L74.1,48.6c-5.3-3-9.5-2.4-12.4,0.6l74.1,73.5L160.6,97.8L160.6,97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160,147l-85.9,48.6c-4.7,3-8.9,2.4-11.9,0l-0.6,0.6l0.6,0.6c3,2.4,7.1,3,11.9,0L160,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.6,195.6c-1.8-1.8-2.4-4.7-2.4-8.3v0.6c0,3.6,1.2,6.5,3,8.3v-0.6H61.6L61.6,195.6z M189.6,130.4L160,147 l0.6,0.6l29-16.6c4.1-2.4,5.9-5.3,5.9-8.3C195.6,125.7,193.2,128.1,189.6,130.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.1,49.2L189.6,115c3.6,2.4,5.9,4.7,5.9,7.7c0-3-1.8-5.9-5.9-8.3L74.1,48.6c-8.3-4.7-14.8-1.2-14.8,8.3v0.6 C59.3,48.6,65.8,44.5,74.1,49.2z"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "Arial, sans-serif",
      fontSize: 43,
      whiteSpace: "pre"
    },
    transform: "matrix(1, 0, 0, 1, 17.607599520796526, -17.607427859417)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 241.532,
    y: 111.284
  }, "EXPLORE IT ON")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 241.532,
    dy: "1.8em"
  }, "\u200B")), /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontSize: 85,
      fontWeight: 700
    }
  }, "Google Play")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.e22b246ed792469305e910d5a8f3cc69.svg";
export { ForwardRef as ReactComponent };